import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import LinkDialog from "../LinkDialog";
import Prompt from '../../widgets/Prompt';
import WorkplaceApprovalSearch from '../workplaceapproval/WorkplaceApprovalSearch';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";

const headCells = [
    { id: 'SDLNumber', numeric: false, disablePadding: true, label: 'SDL Number' },
    { id: "TradeName", numeric: false, disablePadding: true, label: "Trade Name" },
    { id: "LegalName", numeric: false, disablePadding: true, label: "Legal Name" },
    { id: "WorkplaceApprovalNumber", numeric: false, disablePadding: true, label: "Workplace Approval Number" },
    { id: "RegistrationEndDate", numeric: false, disablePadding: true, label: "Coach/Mentor Registration End Date" },
]

const utils = new ViewUtils();
const toolbarRef = React.createRef();

class CoachMentorWorkplaceApprovalSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                CoachMentorID: this.props.location.state.CoachMentorID
            },
            searchParameters: [
                { Name: "CoachMentorID", Value: this.props.location.state.CoachMentorID }
            ],
            linkDialogOpen: false,
            selectedWorkplaceApproval: null,
            propmtOpen: false,
            promptTitle: "Unlink Workplace Approval From Coach/Mentor",
            promptContent: "Are you sure you want to unlink this workplace approval from the coach/mentor?",
            message: "",
            messageStyle: "",
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'link', label: '', tooltip: 'Link Workplace Approval/s to the coach/mentor', icon: 'LinkIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'unlink', label: '', tooltip: 'Un-link the selected workplace approval from the coach/mentor', disabled: utils.isNull(this.state.selectedWorkplaceApproval), icon: 'LinkOffIcon', visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/CoachMentor',
                state: { selection: this.props.location.state.CoachMentorID }
            });
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, message: ""})
        }
        else if ("unlink" === buttonId) {
            this.setState({ promptOpen: true })
        }
    }

    successCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({ selectedWorkplaceApproval: null });
            //Force a refresh
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase(),
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters))
            })
        }
        else if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    unsuccessfulUnlinkCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({ removeMessage: response.Message, removeMessageStyle: response.MessageType.toLowerCase() })
        }
    }

    unlinkCoachMentorWorkplaceApproval(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("unlink", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedWorkplaceApproval}&coachmentorId=${this.props.location.state.CoachMentorID}`
        utils.invokeUrlDelete(fullUrl, this.successCallback, this.unsuccessfulUnlinkCallback);
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                linkDialogOpen: false, selectedWorkplaceApproval: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({
                selectedWorkplaceApproval: selection[0].Id,
                message: "",
                messageStyle: ""
            });
        }
        else {
            this.setState({
                selectedWorkplaceApproval: null,
                message: "",
                messageStyle: ""
            });
        }
        toolbarRef.current.setButtonDisabled("unlink", selection === null || selection.length === 0);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">

                <p className="breadcrumbs">
                    {"Coach/Mentor > Workplace Approvals " + (this.props.location.state.CoachMentorName !== null ? "> " + this.props.location.state.CoachMentorName : "> Add")}
                </p>

                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        ref={toolbarRef}
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />
                    <EnhancedTable
                        headCells={headCells}
                        dataUrl={`api/sims/CoachMentorWorkplaceApproval/GetLinkedCoachMentorWorkplaceApprovals`}
                        height="50vh"
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        searchParameters={this.state.searchParameters} paged={true} />
                </div>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.props.location.state.CoachMentorName}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={`Link Workplace Approval to Coach/Mentor > ${this.props.location.state.CoachMentorName}`}
                    linkName={"WorkplaceApprovals"} postUrl={"api/sims/CoachMentorWorkplaceApproval/linkCoachMentorWorkplaceApproval"}
                    selectionId={this.props.location.state.CoachMentorID}
                    usePost={true}
                >
                    <WorkplaceApprovalSearch
                        dataUrl={"api/sims/CoachMentorWorkplaceApproval/getLinkableCoachMentorWorkplaceApproval"}
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.CoachMentorID} programmeType="Q"
                        mode="lookup"
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => this.unlinkCoachMentorWorkplaceApproval(`api/sims/CoachMentorWorkplaceApproval/RemoveCoachMentorWorkplaceApproval`)}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(connect()(withMenuPermission(CoachMentorWorkplaceApprovalSearch)));